import { render, staticRenderFns } from "./list_registered_products.vue?vue&type=template&id=04279bbe&scoped=true&"
import script from "./list_registered_products.vue?vue&type=script&lang=js&"
export * from "./list_registered_products.vue?vue&type=script&lang=js&"
import style0 from "./list_registered_products.vue?vue&type=style&index=0&id=04279bbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04279bbe",
  null
  
)

export default component.exports